import { forwardRef } from 'react'
import { Link } from 'react-router-dom'
import { Button, ButtonProps } from '@mantine/core'
import { isSpaRoute } from 'utils/isSpaRoute'

interface NavigationButtonProps extends ButtonProps {
  /** Navigation target: SPA route or monolith (Rails) path */
  url: string
  onClick?: () => void
}

/**
 * Button that navigates through react-router when `url` is an SPA route
 * (keeps the persistent Arc shell mounted and preserves cmd/ctrl/middle
 * click), and falls back to a plain anchor (full document load) for
 * monolith pages. Use it when the same call site can point to either —
 * e.g. URLs that depend on a feature flag or on the user profile.
 */
export const NavigationButton = forwardRef<HTMLAnchorElement, NavigationButtonProps>(
  ({ url, ...buttonProps }, ref) => {
    if (isSpaRoute(url)) {
      return <Button ref={ref} component={Link} to={url} {...buttonProps} />
    }
    return <Button ref={ref} component='a' href={url} {...buttonProps} />
  },
)

NavigationButton.displayName = 'NavigationButton'
